import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { SVGAsset } from "res";

/**
 * @function UIPasswordInput
 * @param {STRING} className - Additional classes to add to the UIPasswordInput.
 * @param {STRING} placeholder - Sets the placeholder text.
 * @param {STRING} value - Lets us set a default value if we need to.
 * @param {ReactDOM} inputField - Allows us to target the DOM.
 * @param {FUNCTION} onChange - Allows us to listen for an interaction with the input.
 * @param {dataPoint} dataPoint - data-point to add to wrapper for captures. 
 * @return {React.Component}
 * @exported true
 * @description The UIPasswordInput is used when an input needs to be masked with dots.
 * @example
 * <UIPasswordInput className="added-style" placeholder="Password" />
 */
export default function UIPasswordInput(props) {
  const [ state, setState ] = useState(props.value ?? "");
  const [ revealPassword, setRevealPassword ] = useState(props.revealPassword ?? false);
  const ref = useRef();
  const className = props.className ?? "";
  const placeholder = props.placeholder ?? "";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  // Prop used to immediately set the entered value when "onChange"
  // is called and not wait for values passed to this component.
  const setInputValueOnChange = props.setInputValueOnChange ?? true;

  const onChange = evt => {
    if(props.onChange instanceof Function) {
      if(setInputValueOnChange) setState(ref.current.value);
      props.onChange(ref.current.value, evt);
    } else {
      setState(ref.current.value);
    }
  }

  const onFocus = evt => props.onFocus instanceof Function
  ? props.onFocus(ref.current.value, evt)
  : setState(ref.current.value);

  const onBlur = evt => props.onBlur instanceof Function
  ? props.onBlur(ref.current.value, evt)
  : setState(ref.current.value);
  
  useEffect(() => {
    setState(props.value ?? "");
    setRevealPassword(props.revealPassword ?? false);
  }, [ props.value ]);
  
  let disabled = props.disabled ? {disabled:true}:{}; 

  const onRevealPasswordClick = val => {
    setRevealPassword(!revealPassword);
  }

  return (
    <div className="flex-container flex-horizontal align-center ui-password-input">
      <input type={ revealPassword ? "text" : "password" } autoComplete="new-password" ref={ref} className={className + " ui-text-input"} value={ state }  placeholder={placeholder} onChange={ onChange } onFocus={onFocus} onBlur={onBlur} { ...dataPoint }  {...disabled}/>
      { revealPassword &&
      <SVGAsset id="HideEyeIcon" className="left-inline-icon clickable" onClick={ onRevealPasswordClick } />
      }
      { !revealPassword &&
      <SVGAsset id="EyeIcon" className="left-inline-icon clickable" onClick={ onRevealPasswordClick } />
      }
    </div>
    
  );
}
